import { useDispatch, useSelector } from 'react-redux'
import { getFirstPaper } from '@chegg-wt/core-wa/utils/paperIndexedDb'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import {
  enabledWAFeaturesSelector,
  paperIdSelector,
} from '@chegg-wt/core-wa/state/selectors'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { loggedInSelector } from '@chegg-wt/core/state/user/selectors'

export const useRedirectToWritingAssistantIdPage = () => {
  const dispatch = useDispatch()
  const routes = useRoutesContext()
  const router = useRouter()
  const paperId = useSelector(paperIdSelector)
  const isLoggedIn = useSelector(loggedInSelector)
  const enabledWAFeaturesSelectorFlag = useSelector(enabledWAFeaturesSelector)
  const isMultiPaperEnabled = enabledWAFeaturesSelectorFlag.multiPaper

  useEffect(() => {
    const redirectToWritingAssistantIdPage = async () => {
      const paper = await getFirstPaper()
      if (paper) {
        dispatch(navigated(routes.toWritingAssistant({ paperId: paper.id })))
      }
    }

    if (isMultiPaperEnabled) {
      redirectToWritingAssistantIdPage()
    } else if (!isLoggedIn) redirectToWritingAssistantIdPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const { query } = router
    // ? history api used to prevent re render of all components
    // * update url with paperId if url path not matching
    if (paperId && query.id !== paperId)
      window.history.replaceState(null, '', routes.toWritingAssistant({ paperId }).as)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paperId])
}
